// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import Login from './modules/auth/login';
import Logout from './modules/auth/logout';
import { useAuth } from './modules/auth/AuthContext';
import Home from './modules/home';
import Lp from './modules/lp';
import StripeContainer from './components/Stripe/StripeContainer';
import Header from './components/Common/Header';
import Keyboard from './modules/chatbot/parts/keyboard'
import About from './components/Settings/About';
import Myplan from './components/Settings/Myplan';
import Contact from './components/Settings/Contact';
import Profile from './components/Settings/Profile';
import './App.scss';

function App() {
  const { isLoggedIn, subscriptions } = useAuth();

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={isLoggedIn ? <Navigate to="/home" /> : <Lp />} />
        <Route path="/login" element={!isLoggedIn ? <Login /> : <Navigate to="/home" />} />
        <Route path="/home" element={isLoggedIn ? <Home /> : <Navigate to="/" />} />
        <Route path="/payment" element={isLoggedIn && !subscriptions ? <StripeContainer /> : <Navigate to="/home" />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="profile" element={<Profile />} />
        <Route path="/myplan" element={<Myplan />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;

